import moment from 'moment';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import components from '../algolia';
import {ready, getDocumentLang} from '../main/utils';

const loadPressReleases = () => {
  if (document.querySelector('.press-releases')) {
    new Vue({
      el: '.press-releases',
      comments: true,
      components,
      data() {
        return {
          indexName: this.$algolia.indexPrefix + 'press_releases',
          filterString: null
        };
      },
      methods: {
        formatDate(date) {
          return moment
            .unix(date)
            .locale(getDocumentLang())
            .format('MMMM D, YYYY');
        }
      },
      router
    });
  }
};

ready(() => {
  loadPressReleases();
});
